import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { RemoteDiagnosticsSnapshotsStore, SnapshotType } from '@store';
import { DIAGNOSTICS_CONNECTION_STEP, RemoteDiagnosticsStore } from '@store';

@Component({
  selector: 'app-backup',
  templateUrl: './backup.component.html',
  styleUrls: ['./backup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackupComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  readonly diagnosticsModalStep = DIAGNOSTICS_CONNECTION_STEP;
  readonly snapshotType = SnapshotType;

  gatewaySerial: string;
  installationId: number;
  isActiveSessionAvailable: boolean;
  backupVddsLoaded: boolean;

  constructor(
    public remoteDiagnosticsSnapshotsStore: RemoteDiagnosticsSnapshotsStore,
    public remoteDiagnosticsStore: RemoteDiagnosticsStore,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      this.gatewaySerial = queryParams?.gatewaySerial;
    });
    this.activatedRoute.params.subscribe((params) => {
      this.installationId = params?.id;
    });

    this.remoteDiagnosticsSnapshotsStore.fetchBackups(this.installationId);

    this.remoteDiagnosticsStore
      .isActiveSessionAvailable(this.gatewaySerial)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((isActiveSessionAvailable) => {
        this.isActiveSessionAvailable = isActiveSessionAvailable;
        if (this.isActiveSessionAvailable && !this.backupVddsLoaded) {
          this.remoteDiagnosticsSnapshotsStore.fetchInstallationVddList(this.installationId);
          this.backupVddsLoaded = true;
        }
        this.cdr.detectChanges();
      });
  }

  generateBackup(): void {
    this.remoteDiagnosticsSnapshotsStore.createSnapshot(this.installationId, SnapshotType.BACKUP);
  }

  readCurrentValues(): void {
    this.remoteDiagnosticsSnapshotsStore.hideValues();
    this.startConnection();
  }

  ngOnDestroy(): void {
    this.remoteDiagnosticsSnapshotsStore.selectSnapshot(null);
    this.remoteDiagnosticsSnapshotsStore.setInstallationVddList([]);
    this.remoteDiagnosticsSnapshotsStore.clearDateOfTheValuesRead();
    this.remoteDiagnosticsSnapshotsStore.hideValues();

    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  private startConnection(): void {
    this.remoteDiagnosticsSnapshotsStore.selectSnapshot(null);

    this.remoteDiagnosticsSnapshotsStore.triggerReadVddListValuesForSnapshot(this.gatewaySerial);
  }
}
